/**
 * Soporte para el variant picker en formato cards (snippets/variant-main-picker-cards.liquid).
 *
 * Resuelve el problema de las matrices incompletas: la Gym Monster 2S existe solo en
 * "Monster Pro" y "Monster Pro + Remo", así que al cambiar de modelo la fila de versión
 * puede quedar apuntando a una combinación que no existe. Sin esto, Shopify deja el
 * botón en "No disponible" y el precio desaparece (es el bug que tiene speediance.eu).
 *
 * Dos capas:
 *  1. preCorrect  — corre en fase de captura, antes del componente del tema, y ajusta las
 *                   otras filas para que la petición ya salga con un combo real.
 *  2. repair      — red de seguridad tras cada re-render, por si algo quedó inválido.
 */
(function () {
  var SEL = 'variant-picker.variant-picker--cards';

  function fieldsetsOf(picker) {
    return Array.prototype.slice
      .call(picker.querySelectorAll('fieldset[data-option-position]'))
      .sort(function (a, b) {
        return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
      });
  }

  function matrixOf(picker) {
    var el = picker.querySelector('script[data-variant-matrix]');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) && parsed.length ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function checkedValues(fieldsets) {
    return fieldsets.map(function (fs) {
      var input = fs.querySelector('input[type=radio]:checked');
      return input ? input.value : null;
    });
  }

  function matches(combo, values, upTo) {
    return values.every(function (val, i) {
      if (val === null) return true;
      if (typeof upTo === 'number' && i >= upTo) return true;
      return combo.o[i] === val;
    });
  }

  function exists(matrix, values) {
    return matrix.some(function (combo) {
      return matches(combo, values);
    });
  }

  /* Al cambiar la fila de arriba (el modelo) se vuelve al primer accesorio valido de
     ese modelo, en vez de arrastrar el que estaba elegido: entrar a la 2S viniendo de
     "Pro + Remo" dejaba Pro + Remo, y lo esperable es empezar por la version base.
     El tema resuelve la variante por su cuenta y pisa cualquier `checked` que se ponga
     aqui, asi que se anota y se aplica cuando termina de redibujar. */
  var reinicioPendiente = null;

  function aplicarReinicioPendiente() {
    if (!reinicioPendiente) return;
    var buscado = reinicioPendiente;
    reinicioPendiente = null;
    var fs = document.querySelector('.variant-cards__option[data-option-position="2"]');
    if (!fs) return;
    var radio = Array.prototype.find.call(
      fs.querySelectorAll('input[type=radio]'),
      function (r) { return r.value === buscado; });
    if (radio && !radio.checked) radio.click();
  }

  function reiniciarAccesorio(picker, fieldsets, valores, cambiado) {
    if (cambiado !== 0 || fieldsets.length < 2) return valores;
    var matrix = matrixOf(picker);
    if (!matrix) return valores;
    var primero = null;
    Array.prototype.forEach.call(
      fieldsets[1].querySelectorAll('input[type=radio]'),
      function (radio) {
        if (primero) return;
        var hay = matrix.some(function (combo) {
          var vals = combo.o || combo;
          return vals[0] === valores[0] && vals[1] === radio.value;
        });
        if (hay) primero = radio;
      });
    if (primero && !primero.checked) {
      reinicioPendiente = primero.value;
      valores[1] = primero.value;
    }
    return valores;
  }

  function preCorrect(event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    var picker = input.closest(SEL);
    if (!picker) return;

    var matrix = matrixOf(picker);
    if (!matrix) return;

    var fieldsets = fieldsetsOf(picker);
    var changed = -1;
    fieldsets.forEach(function (fs, i) {
      if (fs.contains(input)) changed = i;
    });
    if (changed === -1) return;

    var values = checkedValues(fieldsets);
    values[changed] = input.value;
    values = reiniciarAccesorio(picker, fieldsets, values, changed);

    var match = matrix.find(function (combo) {
      return matches(combo, values);
    });

    if (!match) {
      // El combo no existe (ej. Gym Monster 2S + Monster, que no se fabrica).
      // Conserva las filas anteriores a la que cambió y, si aun así no hay nada,
      // acepta la primera combinación que respete el valor recién elegido.
      match =
        matrix.find(function (combo) {
          return combo.o[changed] === input.value && matches(combo, values, changed);
        }) ||
        matrix.find(function (combo) {
          return combo.o[changed] === input.value;
        });
      if (!match) return;

      fieldsets.forEach(function (fs, i) {
        if (i === changed) return;
        var target = Array.prototype.find.call(
          fs.querySelectorAll('input[type=radio]'),
          function (radio) {
            return radio.value === match.o[i];
          }
        );
        if (target && !target.checked) target.checked = true;
      });
    }

    // El componente del tema arma la URL con el `data-variant-id` del input clickeado,
    // que viene renderizado para el combo anterior (o vacío). Sin esto se perdía el
    // `?variant=` y bloques como "Incluye:" se quedaban con el texto de la otra versión.
    if (match.id) input.dataset.variantId = String(match.id);
  }

  function repair(picker) {
    var fieldsets = fieldsetsOf(picker);
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      if (fs.dataset.optionPosition === '1') continue;
      var checked = fs.querySelector('input[type=radio]:checked');
      if (!checked || checked.dataset.optionAvailable !== 'false') continue;
      var alt = fs.querySelector('input[type=radio][data-option-available="true"]');
      if (alt) {
        alt.click();
        return;
      }
    }
  }

  // Sincroniza textos que dependen de la opción elegida pero viven fuera del picker
  // (el check "Hasta 100 Kg de peso"). El tema solo re-renderiza el propio picker.
  function sincronizarTextos(picker) {
    var fuente = picker.querySelector('script[data-variant-textos]');
    if (!fuente) return;
    var cfg;
    try {
      cfg = JSON.parse(fuente.textContent);
    } catch (e) {
      return;
    }
    var mapa = cfg.valores || {};
    var destinos = cfg.destinos || {};
    var elegidos = fieldsetsOf(picker).map(function (fs) {
      var i = fs.querySelector('input[type=radio]:checked');
      return i ? i.value : null;
    });
    var valores = {};
    elegidos.forEach(function (v) {
      if (v && mapa[v]) {
        Object.keys(mapa[v]).forEach(function (k) { valores[k] = mapa[v][k]; });
      }
    });
    document.querySelectorAll('[data-variant-texto]').forEach(function (el) {
      var clave = el.getAttribute('data-variant-texto');
      if (valores[clave] != null) el.textContent = valores[clave];
    });
    // Los bloques de texto del tema no aceptan atributos propios: para esos casos el
    // metafield declara un selector en `_destinos`.
    Object.keys(destinos).forEach(function (clave) {
      if (valores[clave] == null) return;
      var sel = destinos[clave];
      if (!sel) return;
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          el.textContent = valores[clave];
        });
      } catch (e) {
        /* selector inválido: se ignora */
      }
    });
  }

  var timer;
  function scheduleRepair() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll(SEL).forEach(function (p) {
        repair(p);
        sincronizarTextos(p);
        // El tema vuelve a dibujar el selector tras cada cambio y se lleva por delante
        // el atributo, asi que hay que remarcarlo aqui y no solo al cargar.
        marcarExistencia(p);
      });
    }, 80);
  }

  var watched = new WeakSet();
  function attach() {
    document.querySelectorAll(SEL).forEach(function (picker) {
      if (watched.has(picker)) return;
      watched.add(picker);
      new MutationObserver(scheduleRepair).observe(picker, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-option-available']
      });
      repair(picker);
      sincronizarTextos(picker);
      marcarExistencia(picker);
      vigilarSecciones();
    });
  }

  // Ficha emergente de un punto de la nota (ej. las PowerGrips).
  // Delegado en document porque el bloque se vuelve a renderizar con cada cambio de variante.
  function ficha(event) {
    var abrir = event.target.closest && event.target.closest('[data-variant-cards-info]');
    if (abrir) {
      var contenedor = abrir.closest('.variant-cards__nota');
      var id = abrir.getAttribute('data-variant-cards-info');
      var dlg = contenedor && contenedor.querySelector('[data-variant-cards-dialog="' + id + '"]');
      if (dlg && typeof dlg.showModal === 'function') {
        event.preventDefault();
        dlg.showModal();
      }
      return;
    }
    var cerrar = event.target.closest && event.target.closest('[data-variant-cards-close]');
    if (cerrar) {
      var propio = cerrar.closest('dialog');
      if (propio) propio.close();
      return;
    }
    // Clic fuera de la tarjeta: el target es el propio <dialog>.
    if (event.target.matches && event.target.matches('dialog.variant-cards__ficha')) {
      event.target.close();
    }
  }


  /* Marca cada valor con si EXISTE una variante para esa combinacion, que no es lo
     mismo que si esta disponible. Shopify llama "no disponible" tanto a la combinacion
     que no existe (2S con banca fija) como a la que existe pero esta agotada. Escondiendo
     por disponibilidad, un modelo recien creado con stock cero dejaba la fila de
     accesorios vacia. Con esto solo desaparece lo que de verdad no se puede armar. */
  function marcarExistencia(picker) {
    var matrix = matrixOf(picker);
    if (!matrix) return;
    var fieldsets = fieldsetsOf(picker);
    var elegidos = checkedValues(fieldsets);
    fieldsets.forEach(function (fs, i) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        // Cada entrada de la matriz es { id, o: [valor1, valor2] }.
        // En cascada: un valor solo se condiciona por las opciones ANTERIORES.
        // Si tambien se miraran las de abajo, elegir "Monster" arriba escondia la 2S,
        // porque la 2S no existe con banca fija.
        var hay = matrix.some(function (combo) {
          var vals = combo.o || combo;
          if (vals[i] !== input.value) return false;
          for (var j = 0; j < i; j++) {
            if (elegidos[j] != null && vals[j] !== elegidos[j]) return false;
          }
          return true;
        });
        input.dataset.existe = hay ? 'true' : 'false';
      });
    });
  }

  function marcarTodos() {
    document.querySelectorAll('variant-picker, .variant-cards').forEach(marcarExistencia);
  }

  /* El tema no actualiza el selector: lo reemplaza por un nodo nuevo. Un observador
     colgado del propio selector muere con el, y por eso la marca se quedaba vieja al
     cambiar de accesorio dentro de la 2S. Se observa la SECCION, que si sobrevive. */
  /* Se marca en el mismo turno que la mutacion, sin espera. El callback del observer
     corre como microtarea, antes de que el navegador pinte, asi que no se alcanza a ver
     la tarjeta que va a esconderse. Con un setTimeout de por medio aparecia un instante
     y desaparecia: eso era el parpadeo. */
  function remarcarPronto() {
    marcarTodos();
    aplicarReinicioPendiente();
  }

  var seccionesVigiladas = new WeakSet();
  function vigilarSecciones() {
    document.querySelectorAll('variant-picker, .variant-cards').forEach(function (picker) {
      var seccion = picker.closest('[id^="shopify-section"]') || document.body;
      if (seccionesVigiladas.has(seccion)) return;
      seccionesVigiladas.add(seccion);
      new MutationObserver(remarcarPronto).observe(seccion, { subtree: true, childList: true });
    });
  }

  document.addEventListener('change', function () { remarcarPronto(); });
  document.addEventListener('shopify:section:load', function () { setTimeout(marcarTodos, 0); });

  document.addEventListener('click', ficha);
  document.addEventListener('change', preCorrect, true);
  document.addEventListener('shopify:section:load', attach);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attach(); marcarTodos(); });
  } else {
    attach();
    marcarTodos();
    vigilarSecciones();
  }
})();
